import { useEffect, useState } from "react";
import { getLebenslaeufe } from "../services/cdn.services";
import "./lebenslauf.page.css";
import { LebenslaufType } from "../types/lebenslauf.type";
import LanguageButton from "../components/languageButton.component";
import React from "react";

function Lebenslauf(
    props: Readonly<{
        isEnglish: boolean;
        setIsEnglish: (newValue: boolean) => void;
    }>
) {
    const { isEnglish, setIsEnglish } = props;

    //Fetch expertise data
    useEffect(() => {
        const fetchData = async () => {
            setLebenslaufData(await getLebenslaeufe());
        };
        fetchData();
    }, [])
    const [lebenslaufData, setLebenslaufData] = useState<LebenslaufType[] | undefined>(undefined);
    
    const [showElements, setShowElements] = useState<number>(0);
    useEffect(() => {
        if (showElements === lebenslaufData?.length) {
            return;
        }
    
        const timeout = setTimeout(() => {
            setShowElements(showElements + 1);
        }, 50);
    
        return () => clearTimeout(timeout);
    }, [showElements]);
    
    return (
        <div id="lebenslauf" className="standard-page">
                <div className="flex column items-center">

                    <div className="flex gap w-100 between items-center mt-5">
                        <div className="remove-on-phone" style={{width: 60}} />
                        <h5>{isEnglish ? "CV" : "Lebenslauf"}</h5>
                        <LanguageButton onToggle={() => setIsEnglish(!isEnglish)} isEnglish={isEnglish} />
                    </div>

                    <div className="lebenslauf-container">
                        {
                            lebenslaufData?.sort((a, b) => {
                                const dateA = a.bis ? a.bis : a.von;
                                const dateB = b.bis ? b.bis : b.von;

                                return dateB.localeCompare(dateA); //Sortiere absteigend (neueste zuerst)
                            })
                                .map((value: LebenslaufType, index: number) => {
                                    return <div className={`content-max-for-mobile ${showElements <= index ? "invisible-item" : "visible-item" } flex gap-4`} key={index}>
                                        <div className="year-container">
                                            {value.von?.substring(0, 4) === value.bis?.substring(0, 4) ?
                                                <p className="year">{value.bis?.substring(0, 4)}</p> :
                                                <p className="year">{value.von && <>{value.von?.substring(0, 4)} {value.bis && value.von && "-"}<br /></>}{value.bis?.substring(0, 4)}</p>
                                            }
                                        </div>
                                        
                                        <div className="flex column gap-1">
                                            <h4>{isEnglish ? value.en_titel : value.titel}</h4>
                                            <div className="flex pb-4">
                                                {lebenslaufData.length !== index + 1 && <div className="line" />}
                                                <p>
                                                    {(isEnglish ? value.en_beschreibung : value.beschreibung)
                                                        ?.split('\n')
                                                        .map((line, i, arr) => (
                                                        <React.Fragment key={i}>
                                                            {line}
                                                            {i < arr.length - 1 && <br />}
                                                        </React.Fragment>
                                                    ))}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                })
                        }
                    </div>
                </div>
        </div>
    );
}

export default Lebenslauf;